import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import googleIcon from "./../assets/google_icon.svg";
import Show from './../assets/show.png';
import Hide from './../assets/hide.png'
import {
  //   handleKeyDown,
  //   handleKeyPress,
  handlePasswordValidation,
  setCookie,
  getCookie,
  deleteCookiesLoginUser,
} from "../commonUtils";
import axios from "axios";
import axiosInstance from "../services/axiosInstance";
import jwt_decode from "jwt-decode";
import "./loginpage.css";

let loginData = {
  email: "",
  password: "",
};
const Loginpage = ({
  handleLoginWithGoogle,
  errorState,
  setUser,
  setIsLoggedIn,
}) => {
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [loginVal, setLoginVal] = useState({ ...loginData });
  const [errorMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  function handleUpdate(event) {
    const targetName = event.target.name;
    const targetVal = event.target.value;
    setLoginVal((prevData) => ({
      ...prevData,
      [targetName]: targetVal,
    }));
  }
/*istanbul ignore next*/
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function handleSubmit() {
    setIsSubmitted(true);
    /*istanbul ignore if*/
    if (
      loginVal.email &&
      isEmailValid &&
      loginVal.password &&
      handlePasswordValidation(loginVal.password)
    ) {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/identity-api/api/v1/users/authenticate`,
          {
            email: loginVal.email,
            password: loginVal.password,
          }
        )
        /*istanbul ignore next*/
        .then((res) => {
          deleteCookiesLoginUser();
          const bearerToken = `Bearer ${res.data.token}`;
          setCookie("authToken", bearerToken);
          setCookie("username", res?.data?.user?.firstName);
          setCookie("email", res?.data?.user?.email);
          setCookie("userGuid", res?.data?.user?.userGuid);
          setCookie("User", JSON.stringify(res?.data?.user));
          setUser(res?.data?.user);
          setIsLoggedIn(true);
          navigate("/home", { replace: true });
          setErrorMsg("");
        })
        .catch((err) => {
          setErrorMsg(err.response.data.message);
        });
    }
  }

  const handleEmailValidation = (e) => {
    const valid =
      /^[\w+.-]+@([\w-]+\.)+[\w-]{2,4}$/g.test(e.target.value) &&
      /*istanbul ignore next*/
      !/^[\d]+@/.test(e.target.value);
    setIsEmailValid(valid);
  };
/*istanbul ignore next*/
  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="email-login">
      <div className="label-input-cls">
        <label className="label-cls" htmlFor="useremail">Email</label>
        <input
          type="email"
          name="email"
          id="useremail"
          className={`form-input ${
            (isSubmitted && !loginVal.email) ||
            (!isEmailValid && loginVal.email)
              ? "input-error"
              : ""
          }`}
          value={loginVal.email}
          onChange={(e) => {
            handleUpdate(e);
            handleEmailValidation(e);
          }}
        />
      </div>
      {!isEmailValid && loginVal.email && (
        <span className="text-error">Please enter a valid email id.</span>
      )}
      {isSubmitted && !loginVal.email ? (
        <span className="text-error">Email is required.</span>
      ) : null}
      <div className="label-input-cls">
        <label className="label-cls" htmlFor="userpassword">Password</label>
        <div style={{ display: "flex",flexDirection: "column" }}>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            id="userpassword"
            className={`form-input ${
              (isSubmitted && !loginVal.password) ||
              (loginVal.password &&
                !handlePasswordValidation(loginVal.password))
                ? "input-error"
                : ""
            }`}
            value={loginVal.password}
            onChange={(e) => {
              handleUpdate(e);
              handlePasswordValidation(e);
            }}
            onKeyDown={(e) => handleEnterKey(e)}
          />
          <button className="showPassword" onClick={togglePasswordVisibility}>
            <img className="show-pswd" src={showPassword ? Show : Hide} alt="show" />
          </button>
        </div>
      </div>
      {loginVal.password && !handlePasswordValidation(loginVal.password) && (
        <span className="text-error">
          Password should be minimum 6 characters.
        </span>
      )}
      {isSubmitted && !loginVal.password ? (
        <span className="text-error">Password is required.</span>
      ) : null}

      <div className="rememberMe">
        <input type="checkbox" id="check" />
        <label className="me-8 line-height-24" htmlFor="rememberMe">
          Remember me
        </label>
      </div>

      <button className="login-btn" onClick={handleSubmit}>
        Login
      </button>
      {errorMsg && <span className="text-error">{errorMsg}</span>}
      {/* <div className="border-div"></div> */}
      <div style={{ margin: "30px" }}>
        { <span style={{ fontWeight: "700", color: "white", margin: "40px" }}>
          or
        </span> }
      </div>
      { <button
        className="buttonTwo googlebtn"
        onClick={() => handleLoginWithGoogle()}
      >
        <img src={googleIcon} alt="Google" /> Login with Google
      </button> }
      {errorState && (
        <div className="error-msg">Your account does not exist.</div>
      )}
    </div>
  );
};

export default Loginpage;
